// mapping of permission levels found in app/includes/user_perms.php
export default {
	NONE: 0,
	VIEW: 1,
	VIEW_REQUEST: 2,
	VIEW_EDIT: 3,
};
